import { IDieuChinhRequest } from "../../../model/request/hoa-don-dien-tu/IDieuChinhRequest";
import { IHoaDonDienTuPagingRequest } from "../../../model/request/hoa-don-dien-tu/IHoaDonDienTuPagingRequest";
import { IPhatHanhRequest } from "../../../model/request/hoa-don-dien-tu/IPhatHanhRequest";
import { IProcessRequest } from "../../../model/request/IProcessRequest";
import { IBienLaiThuViewModel } from "../../../model/respone/bien-lai/IBienLaiThu";
import { IPhatHanhResponse } from "../../../model/respone/hoa-don-dien-tu/IPhatHanhResponse";
import { IPagingResult } from "../../../model/respone/IPagingResult";
import { IHoaDonDienTuView } from "../../reducer-model/hoa-don/IHoaDonDienTuReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export interface IHoaDonDienTuBaseActionTypes<T> {
  request: number;
  data: T;
}

export interface IHoaDonDienTuChonXuat {
  data: IBienLaiThuViewModel[];
  idRemove: number[];
}

export interface IHoaDonDienTuChangeData<T> {
  data: T;
  id_bien_lai: number;
}

export const eHoaDonDienTuActionsObj = {
  LOAD_START: {} as IHoaDonDienTuPagingRequest,
  LOAD_SUCCESS: {} as IPagingResult<IBienLaiThuViewModel[]>,
  LOAD_ERRR: {} as string,

  CHANGE_REQUEST: {} as any,
  SHOW_DETAIL_MODAL: 0,
  HIDE_DETAIL_MODAL: undefined,

  SHOW_HIDE_FILTER: {} as boolean,
  SELECTED_ID: [] as number[],

  PHAT_HANH_START: {} as IPhatHanhRequest,
  PHAT_HANH_SUCCESS: {} as string,
  PHAT_HANH_ERRR: {} as string,

  PHAT_HANH_MULTIPLE_SHOWHIDE_MODAL: false,
  PHAT_HANH_MULTIPLE_SELECTION: {} as IHoaDonDienTuChonXuat,
  PHAT_HANH_MULTIPLE_START: {} as IProcessRequest<IPhatHanhRequest[]>,
  // Máy chủ trả kèm trạng thái xuất hóa đơn ĐỌC LẠI TỪ CSDL của từng phiếu — không được chỉ
  // trông vào SignalR (hub tắt là dòng đã phát hành vẫn hiện chưa, bấm lại thành hóa đơn trùng).
  PHAT_HANH_MULTIPLE_SUCCESS: {} as IPhatHanhResponse[],
  PHAT_HANH_MULTIPLE_ERRR: {} as string,
  PHAT_HANH_MULTIPLE_CANCEL: undefined,
  CHANGE_TRANGTHAI_XUATHOADON: {} as IHoaDonDienTuChangeData<IPhatHanhResponse>,
  PHAT_HANH_MULTIPLE_CHANGE_LOAIHOADON: {} as IHoaDonDienTuChangeData<number>,
  // Đặt ngày hóa đơn ("dd/MM/yyyy") cho MỘT hoặc NHIỀU dòng một lúc.
  PHAT_HANH_MULTIPLE_CHANGE_NGAYHOADON: {} as { id_bien_lais: number[]; ngay: string },

  PHAT_HANH_NHAP_START: {} as IPhatHanhRequest,
  PHAT_HANH_NHAP_SUCCESS: {} as string,
  PHAT_HANH_NHAP_ERRR: {} as string,

  HUY_START: 0,
  HUY_SUCCESS: {} as string,
  HUY_ERRR: {} as string,

  // ky_hieu: tải đúng hóa đơn của ký hiệu đó; bỏ trống = hóa đơn mới nhất của biên lai.
  EXPORT_HOA_DON_START: {} as {
    id_bien_lai: number;
    ten_file?: string;
    ky_hieu?: string;
  },
  EXPORT_HOA_DON_SUCCESS: {} as { data: string; ten_file?: string },
  EXPORT_HOA_DON_ERRR: {} as string,

  SHOW_DIEU_CHINH_MODAL: 0,
  HIDE_DIEU_CHINH_MODAL: undefined,

  DIEU_CHINH_START: {} as IDieuChinhRequest,
  DIEU_CHINH_SUCCESS: {} as string,
  DIEU_CHINH_ERRR: {} as string,

  SYNC_STATUS_START: {} as IProcessRequest<IHoaDonDienTuPagingRequest>,
  SYNC_STATUS_SUCCESS: {} as string,
  SYNC_STATUS_ERRR: {} as string,
  CLOSE_SYNCING_MODAL: undefined,

  VIEW_DETAIL_START: {} as IPhatHanhRequest,
  VIEW_DETAIL_SUCCESS: {} as IHoaDonDienTuView,
  VIEW_DETAIL_ERRR: {} as string,
  VIEW_DETAIL_HIDE_MODAL: undefined,

  PREVIEW_START: {} as IPhatHanhRequest,
  PREVIEW_SUCCESS: {} as IHoaDonDienTuView,
  PREVIEW_ERRR: {} as string,

  EXPORT_EXCEL_CHON_XUAT_START: {} as number[],
  EXPORT_EXCEL_CHON_XUAT_SUCCESS: undefined,
  EXPORT_EXCEL_CHON_XUAT_ERROR: "",

  EXPORT_EXCEL_START: {} as IHoaDonDienTuPagingRequest,
  EXPORT_EXCEL_SUCCESS: undefined,
  EXPORT_EXCEL_ERROR: "",
};
export const eHoaDonDienTuActionTypeIds = generateActionTypeIds(
  eHoaDonDienTuActionsObj,
  "HOA_DON_DIEN_TU"
);
export type IHoaDonDienTuActionTypes = IGenericActionType<
  typeof eHoaDonDienTuActionsObj,
  "HOA_DON_DIEN_TU"
>;
